/*
* @描述: 订单代采明细
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/14 20:47
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="flex_js_wrap purchase_amount_wrap">
                <div>
                    <span>总计：</span>
                    <span class="purchase_cost_price" v-text="'¥'+order_detail.purchase_cost_price"></span>
                </div>
                <el-button size="mini" type="primary" @click="handleClickAddPurchase">新增代采</el-button>
            </div>
            <div v-loading="loading" class="detail_wrap_container">
                <ul class="purchase_detail_list">
                    <li v-for="row in purchaseList"
                        :key="row.order_purchase_id"
                        class="purchase_detail_item">
                        <div class="detail_chunk_wrap">
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">代采编号：</div>
                                <div class="form_item_value flex_js_wrap">
                                <span class="link-label"
                                      @click="handleClickPurchaseDetail(row)"
                                      v-text="row.purchase_num"></span>
                                    <span :class="'purchase_status_name_'+row.status"
                                          class="purchase_status_name"
                                          v-text="row.status_name"></span>
                                </div>
                            </div>
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">代采发起人：</div>
                                <div class="form_item_value">
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard :userId="row.uid">
                                            <template slot="container">
                                                <img :src="row.user_avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.user_name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                            </div>
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">代采时间：</div>
                                <div class="form_item_value" v-text="row.created_at"></div>
                            </div>
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">代采总金额：</div>
                                <div class="form_item_value"
                                     v-text="'¥'+Number(row.actual_total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></div>
                            </div>
                            <div v-if="row.status === 4" class="m_detail_form_item">
                                <div class="form_item_label">作废原因：</div>
                                <div class="form_item_value" v-text="row.cancel_reason"></div>
                            </div>
                        </div>
                        <div v-if="order_detail.order_status===1" class="m_list_handle_wrap">
                            <div v-if="row.status===1"
                                 class="m_list_handle_item"
                                 @click="handleClickEditPurchase(row)">编辑
                            </div>
                            <div v-if="row.status===0"
                                 class="m_list_handle_item primary"
                                 @click="handleClickRevokePurchase(row)">撤销
                            </div>
                            <span v-if="row.status===1" class="line"></span>
                            <div v-if="row.status===1" class="m_list_handle_item danger"
                                 @click="handleClickInvalidate(row)">作废
                            </div>

                            <div v-if="row.status===2||row.status===4"
                                 class="m_list_handle_item primary"
                                 @click="handleClickResubmit(row)">重新发起
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </div>
        <van-popup v-if="invalidatePurchaseDialog"
                   v-model.sync="invalidatePurchaseDialog"
                   :style="{ width: '100%',height: '100%' }"
                   title="作废">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickInvalidatePurchaseCancel"></ReturnNavBar>
                </div>
                <div class="detail_chunk_wrap mb_8">
                    <ul class="order_price_change_list">
                        <li v-for="item in purchaseForm.order_price_change" class="order_price_change_item flex_wrap">
                            <div class="field_name" v-text="item.field_name+'：'"></div>
                            <div>
                                <span class="value_text"
                                      v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                                <i class="iconfont icon-youjiantou"></i>
                                <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="detail_chunk_wrap mb_8">
                    <div class="invalidate_title">作废原因</div>
                    <el-input v-model="cancel_reason"
                              :rows="5"
                              placeholder="作废后，以上订单金额将变更，请输入作废原因"
                              type="textarea"></el-input>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickInvalidatePurchaseConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>
        <OrderPurchaseAdd v-if="orderPurchaseAddVisible"
                          :dialogVisible.sync="orderPurchaseAddVisible"
                          :order_id="order_id"
                          :order_purchase_id.sync="order_purchase_id"
                          @refresh="getPurchaseList"></OrderPurchaseAdd>
        <OrderPurchaseEdit v-if="orderPurchaseEditVisible"
                           :dialogVisible.sync="orderPurchaseEditVisible"
                           :order_id="order_id"
                           :order_purchase_id.sync="order_purchase_id"
                           :purchase_total_amount="purchase_total_amount"
                           @refresh="getPurchaseList"></OrderPurchaseEdit>
        <OrderPurchaseDetail v-if="purchaseDetailDialog"
                             :orderPurchaseId="order_purchase_id"
                             :purchaseDetailDialog.sync="purchaseDetailDialog"/>
    </van-popup>
</template>
<script>
import {
    cancelApproval,
    orderHasAfterSale,
    purchaseCancel,
    purchaseList
} from "@/api";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar";
import OrderPurchaseAdd from '../component/order_purchase_add'
import OrderPurchaseEdit from '../component/order_purchase_edit'
import OrderPurchaseDetail from '../component/order_purchase_detail'

export default {
    name: "purchaseDetail",
    data() {
        return {
            loading: false,
            purchaseList: [],
            orderPurchaseAddVisible: false,
            orderPurchaseEditVisible: false,
            purchaseForm: {
                total_price: '',
                actual_total_price: '',
                discount_price: '',
                remarks: '',
                file: [],
                purchase_details: [
                    {
                        supplier: '',
                        goods_details: [
                            {
                                goods_name: '',
                                price: '',
                                num: undefined,
                                subtotal_price: ''
                            }
                        ],
                        total_amount: ''
                    }
                ],
                order_price_change: [],
                node_list: []
            },
            purchaseFormRules: {
                goods_name: [{required: true, message: '请输入产品名称', trigger: 'blur'}],
                num: [{required: true, message: '请输入数量', trigger: 'blur'}],
            },
            isApproval: 0,
            purchasePrice: 0,
            purchase_total_amount: 0,
            btnDisabled: false,
            defaultImg: require('@/assets/images/default.jpg'),
            order_purchase_id: 0,
            cancel_reason: '',
            invalidatePurchaseDialog: false,
            purchaseDetailDialog: false,
            previewImgList: [],
            previewImgSrc: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0
        },
        order_detail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        order_amount_field: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    components: {
        ReturnNavBar,
        approveProcessSelect,
        PersonnelCard,
        OrderPurchaseAdd,
        OrderPurchaseEdit,
        OrderPurchaseDetail
    },
    created() {
        this.getPurchaseList()
    },
    mounted() {
    },
    methods: {
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取代采列表
        getPurchaseList() {
            this.loading = true
            purchaseList({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.loading = false
                    this.purchaseList = res.data
                }
            })
        },

        //点击代采详情
        handleClickPurchaseDetail(row) {
            this.order_purchase_id = row.order_purchase_id
            this.purchaseDetailDialog = true
        },

        //点击新增代采
        handleClickAddPurchase() {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips + '不允许新增')
                    } else {
                        this.orderPurchaseAddVisible = true
                    }
                }
            })
        },

        //点击撤销代采
        handleClickRevokePurchase(row) {
            this.$dialog.confirm({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990FF',
            }).then(() => {
                cancelApproval({
                    approval_id: row.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功')
                        this.getPurchaseList()
                    }
                })
            })
        },

        //点击作废代采
        handleClickInvalidate(row) {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips + '不允许作废')
                    } else {
                        this.order_purchase_id = row.order_purchase_id
                        this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - parseFloat(row.total_price)
                        this.invalidatePurchaseDialog = true
                        this.computedOrderAmountInfo('purchase_price')
                    }
                }
            })
        },

        //代采作废取消事件
        handleClickInvalidatePurchaseCancel() {
            this.invalidatePurchaseDialog = false
            this.cancel_reason = ''
            this.order_purchase_id = 0
            this.purchaseForm.order_price_change = []
        },

        //代采作废确定事件
        handleClickInvalidatePurchaseConfirm() {
            if (this.cancel_reason === '') return this.$toast.fail('请输入作废原因')
            purchaseCancel({
                order_id: this.order_id,
                order_purchase_id: this.order_purchase_id,
                cancel_reason: this.cancel_reason,
                order_price_change: this.purchaseForm.order_price_change,
                order_updated_at: this.order_detail.updated_at
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('作废成功')
                    this.getPurchaseList()
                    this.handleClickInvalidatePurchaseCancel()
                    this.$emit('refresh')
                }
            })
        },

        //点击编辑代采
        handleClickEditPurchase(row) {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips + '，不允许编辑')
                    } else {
                        console.log(row.order_purchase_id);
                        this.order_purchase_id = row.order_purchase_id
                        this.purchase_total_amount = parseFloat(row.actual_total_price)
                        this.orderPurchaseEditVisible = true
                    }
                }
            })
        },

        //点击重新提交代采
        handleClickResubmit(row) {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips + '，不允许重新提交')
                    } else {
                        this.order_purchase_id = row.order_purchase_id
                        this.orderPurchaseAddVisible = true
                    }
                }
            })
        },
    },
}
</script>
<style lang="scss">
.public_container {
    background-color: #F7F8FA;

    .purchase_amount_wrap {
        padding: 10px 16px;
        background-color: #FFFFFF;
        margin-bottom: 10px;
    }

    .purchase_detail_list {
        .purchase_detail_item {
            margin-bottom: 10px;

            .m_detail_form_item {
                justify-content: start;

                .form_item_value {
                    text-align: left;
                }

                .link-label {
                    color: #2990FF;
                }

                .purchase_status_name {
                    color: #666666;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 4px;
                    }

                    &.purchase_status_name_0::before {
                        background: #F0AA32;
                    }

                    &.purchase_status_name_1::before {
                        background: #5AB333;
                    }

                    &.purchase_status_name_2::before {
                        background: #E44144;
                    }

                    &.purchase_status_name_3::before {
                        background: #BFBFBF;
                    }
                }
            }
        }
    }

    .order_price_change_list {
        margin-bottom: 0;

        .order_price_change_item {
            .field_name {
                font-size: 14px;
                line-height: 22px;
                margin-bottom: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .el-textarea {
        .el-textarea__inner {
            padding: 0;
            border: none;
        }
    }
}
</style>